import { getFormattedRefWithVerses, type ReadingPlanDay, ReadingPlanStatus } from '@soulhx/fs-common';

/**
 * OT/NT verse counts for a passage, plus its formatted reference (without
 * "unnecessary" verses) - returned together since both come from the same
 * (relatively expensive) parse, so callers can render the reference without
 * parsing again
 */
export const getOtNtPassageStatsFromOsis = (
  osis?: string
): { otVerses: number; ntVerses: number; formattedRef: string } => {
  if (!osis) return { otVerses: 0, ntVerses: 0, formattedRef: '' };

  const parsedObj = getFormattedRefWithVerses(osis, { includeVerses: false });
  const ntVerses = parsedObj.verses.filter((verse) => verse.newTestament).length;
  return { otVerses: parsedObj.verses.length - ntVerses, ntVerses, formattedRef: parsedObj.formattedRef };
};

/**
 * Calculates the variant (and button variant) to use for Bootstrap
 * colours for this reading plan item.
 *
 * @param plan Current plan day item
 * @returns a variant and button variant to use for Bootstrap
 */
export const getReadingPlanClass = (plan: ReadingPlanDay): string => {
  if (plan.dayCompleted) return 'rpi-completed';

  if (plan.readingPlanStatus === ReadingPlanStatus.red) return 'rpi-red';

  if (plan.readingPlanStatus === ReadingPlanStatus.yellow) return 'rpi-yellow';

  return 'rpi-base';
};
